import { Layout } from 'components/Layout'
import { BatchArchived } from 'features/autocheck/components/Archived'
import { AwaitingEOB } from 'features/autocheck/components/AwaitingEOB'
import { ClaimFiles } from 'features/autocheck/components/ClaimFiles'
import { EOBReview } from 'features/autocheck/components/EOBReview'
import { BatchProcessed } from 'features/autocheck/components/Processed'
import { BatchProcessing } from 'features/autocheck/components/Processing'
import { AutoCheck } from 'pages/AutoCheck/AutoCheck'
import { PathsEnum } from 'pages/Paths'
import { Navigate, Route, Routes } from 'react-router-dom'

const AutoCheckRouter = () => {
  return (
    <Layout>
      <Routes>
        {/* valid routes */}
        <Route path={PathsEnum.root} element={<AutoCheck />}>
          <Route path={PathsEnum.root} element={<Navigate to={PathsEnum.batchProcessed} />} />
          <Route path={PathsEnum.batchPending} element={<ClaimFiles />} />
          <Route path={PathsEnum.batchUpload} element={<ClaimFiles />} />
          <Route path={PathsEnum.batchProcessing} element={<BatchProcessing />} />
          <Route path={PathsEnum.batchAwaiting} element={<AwaitingEOB />} />
          <Route path={PathsEnum.batchProcessed} element={<BatchProcessed />} />
          <Route path={PathsEnum.batchArchive} element={<BatchArchived />} />
          <Route path={PathsEnum.eobReview} element={<EOBReview />} />
          {/* <Route path={PathsEnum.unSupportedFax} element={<UnSupportedFax />} /> */}
          <Route
            path={PathsEnum.batchArchive}
            element={
              <>
                <h1>Batch Archived</h1>
              </>
            }
          />
        </Route>
      </Routes>
    </Layout>
  )
}

export { AutoCheckRouter }
